import ISDashboard from './ISDashboard';

export default ISDashboard;
